import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ImportsListComponent } from './imports-list/imports-list.component';
import { ImportsDetailComponent } from './imports-detail/imports-detail.component';

const routes: Routes = [
    {
        path: 'imports',
        children: [
            { path: '', component: ImportsListComponent }
        ]
    },
    {
        path: 'imports/:id',
        children: [
            { path: '', component: ImportsDetailComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ImportsRoutingModule { }
